import React from "react";
import list from "javascriptstuff-db/view-libraries";

import Page from "../../components/common/Page";
import ListPageContainer from "../../components/list/ListPageContainer";
import StyledTextBlock from "../../components/common/StyledTextBlock";
import addNotes from "../../logic/addNotes";
import Link from "../../components/common/Link";

const extendedList = addNotes(list, {
  "elm-lang/elm-compiler": `This is actually a language created specifically for creating webapps. This is not technically a JavaScript tool, but it compiles to JavaScript.`,
  "facebook/react-native": `This one doesn't actually run in the browser or create webapps. It helps you create views in iOS and Android apps.`,
  "facebook/react": (
    <StyledTextBlock>
      Also check out the React-specific lists:{` `}
      <Link to="/react-tutorials">tutorials</Link>,{` `}
      <Link to="/react-starter-projects">starter projects</Link>,{` `}
      <Link to="/react-example-apps">example apps</Link>, and{` `}
      <Link to="/react-components">components</Link>.
    </StyledTextBlock>
  )
});

export default () => (
  <Page>
    <ListPageContainer list={extendedList}>
      <StyledTextBlock>
        <p>
          View libraries render your app in the browser. You provide some code
          or data in a format that is specific to the library, and the library
          handles rendering your DOM elements.
        </p>
        <p>
          The more traditional alternative to a view library is server
          templates. Templates work well when the DOM doesn't change much in the
          browser.
        </p>
        <p>
          View libraries become essential when your frontend has a high degree
          of interactivity. Using a view library creates an abstraction layer
          between your code and the DOM. This can often lead to simpler, more
          maintainable code.
        </p>
      </StyledTextBlock>
    </ListPageContainer>
  </Page>
);



// WEBPACK FOOTER //
// ./src/pages/list/view-libraries.js